import script from "./SecondFormPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SecondFormPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__